module.exports = __webpack_public_path__ + "b7a3257fffe0df9f5137c714409274f2.svg";